import { render, staticRenderFns } from "./RecentSalesOrder.vue?vue&type=template&id=47405709"
import script from "./RecentSalesOrder.vue?vue&type=script&lang=js"
export * from "./RecentSalesOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports